import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import { UserSettings } from '../types';
import env from '@/env';

export const getUserSettingsForMe = async (): Promise<UserSettings> => {
  const fetchResponse = await fetch(`${env.VITE_API_URL}/pb/s/api/sqo-portal/users/me/settings`, {
    method: 'GET',
    headers: {
      authenticate: localStorage.getItem('accessToken') || '',
    },
  });

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as UserSettings;
  return response;
};
